import { useAnimations, useGLTF, useTexture } from "@react-three/drei";
import { useEffect, useRef } from "react";
import { DissolveMaterial } from "./customMaterials/DissolveMaterial";

const HumanScale = (props) => {
  const scene = useGLTF(
    "https://models.readyplayer.me/636a9b5bb95979d9c7b26db3.glb"
  );

  const group = useRef();
  const { nodes, materials, animations } = useGLTF("/avatar-optim.glb");
  const { actions } = useAnimations(animations, group);

  const startTextureEN = useTexture("/startEN.png");
  const startTextureFR = useTexture("/startFR.png");

  useEffect(() => {
    return () => {
      useGLTF.clear(
        "https://models.readyplayer.me/636a9b5bb95979d9c7b26db3.glb"
      );
      useGLTF.clear("/avatar-optim.glb");
    };
  }, []);

  useEffect(() => {
    if (Object.keys(actions).length > 0 && props.config) {
      const modelAnimation = Object.keys(actions)[0];
      actions[modelAnimation].play();
    }
    // actions.idle.play();
  }, [actions, props.config]);

  return (
    <group {...props}>
      {props.config ? (
        <>
          <group position={[0, 2.2, 0]} scale={[1, 0.4, 0.1]}>
            <sprite>
              {navigator.language === "fr" ? (
                <spriteMaterial attach="material" map={startTextureFR} />
              ) : (
                <spriteMaterial attach="material" map={startTextureEN} />
              )}
            </sprite>
          </group>
          <group ref={group} {...props} dispose={null}>
            <group name="Scene">
              <group name="Armature">
                <skinnedMesh
                  name="Wolf3D_Avatar"
                  geometry={nodes.Wolf3D_Avatar.geometry}
                  // material={materials.Wolf3D_Avatar}
                  skeleton={nodes.Wolf3D_Avatar.skeleton}
                  morphTargetDictionary={
                    nodes.Wolf3D_Avatar.morphTargetDictionary
                  }
                  morphTargetInfluences={
                    nodes.Wolf3D_Avatar.morphTargetInfluences
                  }
                >
                  <DissolveMaterial baseMaterial={materials.Wolf3D_Avatar} />
                </skinnedMesh>
                <primitive object={nodes.Hips} />
              </group>
              <group
                name="iPad_JOINED"
                // position={[0.028, 1.247, 0.361]}
                rotation={[-0.436, -0.094, 0.199]}
              >
                <mesh
                  name="Cube008"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube008.geometry}
                  // material={materials.iPadMaterial}
                >
                  <DissolveMaterial baseMaterial={materials.iPadMaterial} />
                </mesh>
                <mesh
                  name="Cube008_1"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube008_1.geometry}
                  // material={materials.iPadScreen}
                >
                  <DissolveMaterial baseMaterial={materials.iPadScreen} />
                </mesh>
                <mesh
                  name="Cube008_2"
                  castShadow
                  receiveShadow
                  geometry={nodes.Cube008_2.geometry}
                  // material={materials.iPadContourMaterial}
                >
                  <DissolveMaterial
                    baseMaterial={materials.iPadContourMaterial}
                  />
                </mesh>
              </group>
            </group>
          </group>
        </>
      ) : (
        <>
          <primitive object={scene.nodes.Hips} />
          <skinnedMesh
            name="Wolf3D_Avatar"
            geometry={scene.nodes.Wolf3D_Avatar.geometry}
            material={scene.materials.Wolf3D_Avatar}
            skeleton={scene.nodes.Wolf3D_Avatar.skeleton}
            morphTargetDictionary={
              scene.nodes.Wolf3D_Avatar.morphTargetDictionary
            }
            morphTargetInfluences={
              scene.nodes.Wolf3D_Avatar.morphTargetInfluences
            }
          />
        </>
      )}
    </group>
  );
};

// useGLTF.preload("https://models.readyplayer.me/636a9b5bb95979d9c7b26db3.glb");
// useGLTF.preload("/avatar-optim.glb");

export default HumanScale;
